import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {FOR_YOU_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {disableDynamicPositionProps} from "../../offer/list/hooks/use_list_dynamic_positions";
import {OfferType} from "../../offer/types/OfferType";
import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {RegionType} from "../../region/types/RegionType";
import {useAppDispatch} from "../../store/hooks";
import {openForYouModal} from "../state/for_you_modal_slice";
import {ForYouBannerGtmEvent} from "../tracking/for_you_banner_gtm_events";
import {ConsultantBox} from "./ConsultantBox";

const background = require("../images/for_you_banner.png");

interface IProps {
    offerTypes: OfferType[];
    selectedRegion: ISelectedRegion[];
}

export const ForYouBanner = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();

    const {data: regions} = useGetRegionDetailListQuery(
        {regionIds: props.selectedRegion.map((region) => region.id)},
        {skip: props.selectedRegion.length === 0}
    );

    const getRegionCity = () => {
        const cityInRegions = regions?.length && regions.find((region) => region.type === RegionType.CITY);
        if (cityInRegions) {
            return cityInRegions.name;
        }
        if (regions) {
            return regions[0]?.parent?.name || "";
        }
        return "";
    };

    return (
        <li className={container} {...disableDynamicPositionProps()}>
            <div className={bannerWrapper} data-testid={FOR_YOU_TEST_IDS.FOR_YOU_BANNER}>
                <Image width="100%" height="100%" alt="tło banera" src={background} className={bannerStyle} />

                <div className={bannerTexts}>
                    <Text variant="headline_2" as="p" align={isMobile ? "center" : "left"} className={css({order: 1, md: {order: 1}})}>
                        Nie masz czasu przeglądać wszystkich ofert?
                    </Text>

                    <Text variant="body_copy_1" align={isMobile ? "center" : "left"} className={css({order: 2, md: {order: 2}})}>
                        Powiedz mi, jakiego mieszkania szukasz, a <strong>bezpłatnie i szybko</strong> znajdę dla Ciebie oferty spełniające Twoje oczekiwania
                        oraz doradzę w wyborze najlepszej!
                    </Text>

                    <ConsultantBox className={css({order: 0, mb: 2, md: {order: 3, mt: 2, mb: 0}})} />
                </div>

                <Button
                    className={buttonStyle}
                    variant="outlined_secondary"
                    onClick={() => {
                        ForYouBannerGtmEvent(getRegionCity());
                        dispatch(openForYouModal(props.offerTypes));
                    }}
                    dataTestId={FOR_YOU_TEST_IDS.FOR_YOU_BANNER_BUTTON}
                >
                    Wypełnij formularz
                </Button>
            </div>
        </li>
    );
};

const container = css({
    flex: "0 0 100%",
    px: 1.5
});

const bannerWrapper = css({
    position: "relative",
    backgroundColor: "var(--colors-background-200)",
    px: 1.5,
    py: "3.5rem",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 3,
    maxWidth: 375,
    margin: "auto",

    md: {
        px: 8,
        py: 3,
        gap: 2,
        flexDirection: "row",
        maxWidth: "unset"
    },

    lg: {
        gap: 3,
        flexWrap: "unset"
    }
});

const bannerStyle = css({
    display: "none",

    md: {
        display: "block",
        position: "absolute",
        inset: 0,
        opacity: "50%",
        borderRadius: 2
    }
});

const bannerTexts = css({
    display: "flex",
    gap: 1,
    flexDirection: "column",
    alignItems: "center",

    md: {
        alignItems: "start",
        maxWidth: 656,
        zIndex: 1
    },
    lg: {
        maxWidth: 784
    }
});

const buttonStyle = css({
    w: "100%",
    minWidth: "261px",
    px: 5,

    md: {
        w: "auto"
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {FOR_YOU_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {disableDynamicPositionProps} from "../../offer/list/hooks/use_list_dynamic_positions";
import {OfferType} from "../../offer/types/OfferType";
import {useGetRegionDetailListQuery} from "../../region/api/get_region_detail_list";
import {RegionType} from "../../region/types/RegionType";
import {useAppDispatch} from "../../store/hooks";
import {openForYouModal} from "../state/for_you_modal_slice";
import {ForYouBannerGtmEvent} from "../tracking/for_you_banner_gtm_events";
import {ConsultantBox} from "./ConsultantBox";

const background = require("../images/for_you_banner.png");

interface IProps {
    offerTypes: OfferType[];
    selectedRegion: ISelectedRegion[];
}

export const ForYouBanner = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();

    const {data: regions} = useGetRegionDetailListQuery(
        {regionIds: props.selectedRegion.map((region) => region.id)},
        {skip: props.selectedRegion.length === 0}
    );

    const getRegionCity = () => {
        const cityInRegions = regions?.length && regions.find((region) => region.type === RegionType.CITY);
        if (cityInRegions) {
            return cityInRegions.name;
        }
        if (regions) {
            return regions[0]?.parent?.name || "";
        }
        return "";
    };

    return (
        <li className={container} {...disableDynamicPositionProps()}>
            <div className={bannerWrapper} data-testid={FOR_YOU_TEST_IDS.FOR_YOU_BANNER}>
                <Image width="100%" height="100%" alt="tło banera" src={background} className={bannerStyle} />

                <div className={bannerTexts}>
                    <Text variant="headline_2" as="p" align={isMobile ? "center" : "left"} className={css({order: 1, md: {order: 1}})}>
                        Nie masz czasu przeglądać wszystkich ofert?
                    </Text>

                    <Text variant="body_copy_1" align={isMobile ? "center" : "left"} className={css({order: 2, md: {order: 2}})}>
                        Powiedz mi, jakiego mieszkania szukasz, a <strong>bezpłatnie i szybko</strong> znajdę dla Ciebie oferty spełniające Twoje oczekiwania
                        oraz doradzę w wyborze najlepszej!
                    </Text>

                    <ConsultantBox className={css({order: 0, mb: 2, md: {order: 3, mt: 2, mb: 0}})} />
                </div>

                <Button
                    className={buttonStyle}
                    variant="outlined_secondary"
                    onClick={() => {
                        ForYouBannerGtmEvent(getRegionCity());
                        dispatch(openForYouModal(props.offerTypes));
                    }}
                    dataTestId={FOR_YOU_TEST_IDS.FOR_YOU_BANNER_BUTTON}
                >
                    Wypełnij formularz
                </Button>
            </div>
        </li>
    );
};

const container = css({
    flex: "0 0 100%",
    px: 1.5
});

const bannerWrapper = css({
    position: "relative",
    backgroundColor: "var(--colors-background-200)",
    px: 1.5,
    py: "3.5rem",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 3,
    maxWidth: 375,
    margin: "auto",

    md: {
        px: 8,
        py: 3,
        gap: 2,
        flexDirection: "row",
        maxWidth: "unset"
    },

    lg: {
        gap: 3,
        flexWrap: "unset"
    }
});

const bannerStyle = css({
    display: "none",

    md: {
        display: "block",
        position: "absolute",
        inset: 0,
        opacity: "50%",
        borderRadius: 2
    }
});

const bannerTexts = css({
    display: "flex",
    gap: 1,
    flexDirection: "column",
    alignItems: "center",

    md: {
        alignItems: "start",
        maxWidth: 656,
        zIndex: 1
    },
    lg: {
        maxWidth: 784
    }
});

const buttonStyle = css({
    w: "100%",
    minWidth: "261px",
    px: 5,

    md: {
        w: "auto"
    }
});
